import { describeExpiration, getExpiration } from "../../../Utils/expiration";
import "./ExpirationDate.css";

// Fecha de vencimiento coloreada: roja si ya ha vencido, naranja (aviso) si
// faltan los días de aviso del elemento (advise_days) o menos, y verde si es posterior
export default function ExpirationDate(props: { date: any; adviseDays?: any }) {
  const expiration = getExpiration(props.date, props.adviseDays);
  if (!expiration) {
    return <span className="expirationDate expirationDate--none">Sin vencimiento</span>;
  }
  return (
    <span
      className={`expirationDate expirationDate--${expiration.status}`}
      title={describeExpiration(expiration)}
    >
      {expiration.formatted}
    </span>
  );
}
